module.exports = (__webpack_require__(48033))(5482);